import { FC } from 'react';
import styled from 'styled-components';
import { FlagListType } from '../Icon/constants';
import Icon from '../Icon/Icon';
import { PLACEHOLDER_FLAG } from './constants';
import { FlagIconProps, StyledFlagProps } from './types';

const StyledFlagIcon = styled(Icon)<StyledFlagProps>`
  border-radius: 50%;
`;

/**
 *  Component used to show the flags from different countries. Requires `size` and a `country` to properly render.
 */

const FlagIcon: FC<FlagIconProps> = ({ size, country, title, className }) => {
  const countryName = country
    ? (country.toUpperCase() as FlagListType)
    : PLACEHOLDER_FLAG;

  return (
    <StyledFlagIcon
      width={size}
      height={size}
      role="img"
      name={countryName}
      className={className}
      title={title}
    />
  );
};

export default FlagIcon;
